import * as ExclusionProvider from "../providers/exclusion-provider";
import * as GeneralRepository from "../repositories/general-repository";
import * as ProductoMapper from "../mappers/producto-mapper";

export const obtenerBeneficiosProducto = async (productos) => {
    console.log("obtenerExclusiones0")
    const request = ProductoMapper.mapProductosToNombreProductos(productos)
    const response = await ExclusionProvider.obtenerExclusiones(request)
    // if(response.auditResponse.codigoRespuesta === '0') {
    //     return {
    //         error: null,
    //         exclusiones: response.entity
    //     }
    // } else {
    //     if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
    //         const responseToken = await GeneralRepository.renovarToken()
    //         if(responseToken !== null && responseToken.error === null) {
    //             return await obtenerBeneficiosProducto(productos)
    //         } else {
    //             return {
    //                 error: response.auditResponse,
    //                 exclusiones: null
    //             }
    //         }
    //     } else {
    //         return {
    //             error: response.auditResponse,
    //             exclusiones: null
    //         }
    //     }
    // }
    if(response && response.datos !== undefined && response.datos !== null) {
        return {
            error: null,
            exclusiones: response.datos
        }
    } else {
        return {
            error: response,
            exclusiones: null
        }
    }
}